/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_Q5Inputs */

const es_marketplace_seo_galicia_faq_q5 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué diferencia hay entre Sálvora y las Cíes?`)
};

const gl_marketplace_seo_galicia_faq_q5 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que diferenza hai entre Sálvora e as Cíes?`)
};

const en_marketplace_seo_galicia_faq_q5 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between Sálvora and Cíes?`)
};

/**
* | output |
* | --- |
* | "What is the difference between Sálvora and Cíes?" |
*
* @param {Marketplace_Seo_Galicia_Faq_Q5Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_q5 = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_Q5Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_Q5Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_q5(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_q5(inputs)
	return es_marketplace_seo_galicia_faq_q5(inputs)
});